// Mock data for development and testing

export const mockProducts = [
	{
		id: 1,
		name: 'Sand - Fine',
		description: 'Premium fine sand for concrete',
		category: 'Aggregates',
		unit: 'kg',
		pricePerUnit: 0.05
	},
	{
		id: 2,
		name: 'Gravel - 20mm',
		description: 'Standard construction gravel',
		category: 'Aggregates',
		unit: 'kg',
		pricePerUnit: 0.08
	},
	{
		id: 3,
		name: 'Crushed Stone',
		description: 'Limestone crushed stone',
		category: 'Stone',
		unit: 'kg',
		pricePerUnit: 0.12
	},
	{
		id: 4,
		name: 'Sand - Coarse',
		description: 'Coarse sand for foundations',
		category: 'Aggregates',
		unit: 'kg',
		pricePerUnit: 0.06
	},
	{
		id: 5,
		name: 'Recycled Concrete',
		description: 'Environmentally friendly recycled aggregate',
		category: 'Recycled',
		unit: 'kg',
		pricePerUnit: 0.04
	},
	{
		id: 6,
		name: 'Topsoil Premium',
		description: 'High-quality topsoil for landscaping',
		category: 'Soil',
		unit: 'kg',
		pricePerUnit: 0.15
	}
];

export const mockCustomers = [
	{
		id: 1,
		name: 'ABC Construction Ltd',
		contact: 'John Smith',
		phone: '+64 3 123 4567',
		email: 'john@abcconstruction.co.nz',
		address: '123 Builder Street, Christchurch',
		creditLimit: 50000,
		currentBalance: 12500
	},
	{
		id: 2,
		name: 'XYZ Builders',
		contact: 'Jane Doe',
		phone: '+64 3 234 5678',
		email: 'jane@xyzbuilders.co.nz',
		address: '456 Construction Ave, Christchurch',
		creditLimit: 30000,
		currentBalance: 8750
	},
	{
		id: 3,
		name: 'Metro Development',
		contact: 'Mike Johnson',
		phone: '+64 3 345 6789',
		email: 'mike@metrodev.co.nz',
		address: '789 Development Road, Christchurch',
		creditLimit: 100000,
		currentBalance: 25000
	},
	{
		id: 4,
		name: 'Southern Contractors',
		contact: 'Sarah Wilson',
		phone: '+64 3 456 7890',
		email: 'sarah@southerncontractors.co.nz',
		address: '321 Industrial Lane, Christchurch',
		creditLimit: 75000,
		currentBalance: 18900
	}
];

export const mockProjects = [
	{
		id: 1,
		name: 'Residential Complex A',
		customerId: 1,
		address: '100 Housing Estate, Christchurch',
		startDate: '2024-01-15',
		estimatedCompletion: '2024-12-15',
		status: 'In Progress',
		totalBudget: 2500000
	},
	{
		id: 2,
		name: 'Office Building Downtown',
		customerId: 1,
		address: '50 Business District, Christchurch',
		startDate: '2024-03-01',
		estimatedCompletion: '2025-06-30',
		status: 'In Progress',
		totalBudget: 5000000
	},
	{
		id: 3,
		name: 'Shopping Center',
		customerId: 2,
		address: '200 Retail Plaza, Christchurch',
		startDate: '2024-02-01',
		estimatedCompletion: '2024-11-30',
		status: 'In Progress',
		totalBudget: 8000000
	},
	{
		id: 4,
		name: 'Highway Extension',
		customerId: 3,
		address: 'State Highway 1 Extension',
		startDate: '2024-04-01',
		estimatedCompletion: '2025-03-31',
		status: 'Planning',
		totalBudget: 15000000
	},
	{
		id: 5,
		name: 'School Renovation',
		customerId: 4,
		address: '75 Education Street, Christchurch',
		startDate: '2024-01-20',
		estimatedCompletion: '2024-08-20',
		status: 'Near Completion',
		totalBudget: 1200000
	}
];

export const mockTrucks = [
	{
		id: 1,
		licensePlate: 'ABC123',
		fleetNumber: 'T-001',
		tareWeight: 15000,
		maxGrossWeight: 44000,
		registeredDate: '2024-01-15',
		lastService: '2024-07-15',
		driver: 'Tom Anderson',
		company: 'ABC Construction Ltd'
	},
	{
		id: 2,
		licensePlate: 'XYZ456',
		fleetNumber: 'T-002',
		tareWeight: 16500,
		maxGrossWeight: 44000,
		registeredDate: '2024-02-20',
		lastService: '2024-08-01',
		driver: 'Lisa Chen',
		company: 'XYZ Builders'
	}
];

export const mockTickets = [
	{
		id: 1001,
		ticketNumber: 'TKT-2024-001001',
		date: '2024-08-15',
		time: '09:15:30',
		licensePlate: 'ABC123',
		customerId: 1,
		projectId: 1,
		productId: 1,
		tareWeight: 15000,
		grossWeight: 35000,
		netWeight: 20000,
		price: 1000.00,
		status: 'Completed'
	},
	{
		id: 1002,
		ticketNumber: 'TKT-2024-001002',
		date: '2024-08-15',
		time: '11:30:45',
		licensePlate: 'XYZ456',
		customerId: 2,
		projectId: 3,
		productId: 2,
		tareWeight: 16500,
		grossWeight: 42000,
		netWeight: 25500,
		price: 2040.00,
		status: 'Completed'
	}
];

// Helper functions for working with mock data
export const getCustomerById = (id) => mockCustomers.find(c => c.id === id);
export const getProductById = (id) => mockProducts.find(p => p.id === id);
export const getProjectById = (id) => mockProjects.find(p => p.id === id);
export const getTruckByPlate = (plate) => mockTrucks.find(t => t.licensePlate === plate);

export const getProjectsByCustomer = (customerId) =>
	mockProjects.filter(p => p.customerId === customerId);

export const getRecentlyUsedProducts = (limit = 3) =>
	mockProducts.slice(0, limit);

export const getRecentlyUsedCustomers = (limit = 2) =>
	mockCustomers.slice(0, limit);